import { MatDialog } from "@angular/material/dialog";
import { Injectable, inject } from "@angular/core";

import { LoadingDialogComponent } from "@layouts/loading-dialog/loading-dialog.component";

import { dialogConfig } from "./data";

@Injectable({
  providedIn: "root",
})
export class LoadingDialogService {
  dialog = inject(MatDialog);

  show(message = "") {
    const config = {
      ...dialogConfig,
      data: {
        message,
      },
    };

    this.dialog.open(LoadingDialogComponent, config);
  }

  close() {
    this.dialog.closeAll();
  }
}
